import { GameUpdateData } from "@lib/titan2-slingo/dist/api/model/data/GameUpdateData";
import { GameState } from "@lib/titan2-slingo/dist/api/model/enum/GameState";
import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { ExtendedGameProgressData } from "./ExtendedGameProgressData";
import { ExtendedSpinResultData } from "./ExtendedSpinResultData";
import { ExtendedClientDataData } from "./ExtendedClientDataData";
import { Action } from "@lib/titan2-slingo/dist/api/model/enum/Action";
/**
 * ExtendedGameUpdateData.ts
 */
export class ExtendedGameUpdateData extends GameUpdateData {
    solidify() {
        if (this.dataExists(this.data)) {
            this.gameId = this.data.getNumber(SlingoConstants.PROPERTY_GAME_ID);
            this.gameInstanceId = this.data.getNumber(SlingoConstants.PROPERTY_GAME_INSTANCE_ID);
            this.state = GameState.getState(this.data.getString(SlingoConstants.PROPERTY_STATE));
            this.solidifyProgress();
            this.solidifyActions();
            this.solidifyResult();
            this.solidifySpinPrice();
            this.solidifySymbolWins();
            this.solidifyPatternWin();
            this.solidifyBalance();
            this.solidifyInitialBalance();
            this.solidifyClient();
            this.solidifyFreeGamesRemaining();
            this.solidifyFreeGameStake();
            this.solidifyLastStake();
            this.solidifyClientData();
            this.updateBalanceManager();
        }
    }
    updateBalanceManager() {
        if (this.getActions().includes(Action.COLLECT)) {
            return;
        }
        super.updateBalanceManager();
    }
    solidifyClientData() {
        this.clientDataData = new ExtendedClientDataData(this.data);
    }
    getClientData() {
        return this.clientDataData;
    }
    solidifyProgress() {
        let progressData = this.data.getDataObject(SlingoConstants.PROPERTY_GAME_PROGRESS);
        if (this.dataExists(progressData)) {
            this.progress = new ExtendedGameProgressData(progressData);
        }
    }
    solidifyResult() {
        let resultData = this.data.getDataObject(SlingoConstants.PROPERTY_SPIN_RESULT);
        if (this.dataExists(resultData)) {
            this.result = new ExtendedSpinResultData(resultData);
        }
    }
}
//# sourceMappingURL=ExtendedGameUpdateData.js.map